import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchActiveSessions } from '../services/sessionLogsService';
import { SessionLogsState } from '../types/sessionLogs.types';

const initialState: SessionLogsState = {
    sessions: [],
    total: 0,
    page: 1,
    pages: 1,
    loading: false,
    error: null,
};

export const fetchSessionLogsThunk = createAsyncThunk(
    'sessionLogs/fetch',
    async ({ page }: { page: number }, { rejectWithValue }) => {
        try {
            return await fetchActiveSessions(page);
        } catch (err: any) {
            return rejectWithValue(
                err?.response?.data?.message ?? 'Failed to load sessions'
            );
        }
    }
);

const sessionLogsSlice = createSlice({
    name: 'sessionLogs',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSessionLogsThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSessionLogsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.sessions = action.payload.sessions;
                state.total = action.payload.total;
                state.page = action.payload.page;
                state.pages = action.payload.pages;
            })
            .addCase(fetchSessionLogsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default sessionLogsSlice.reducer;
